import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { RecordInfo } from "../components/dashboard/Record/types";

export const recordInfoKeys = {
  all: ["recordInfo"] as const,
  detail: (patientId: string) => ["recordInfo", patientId] as const,
};

export function useRecordInfoQuery(patientId?: string | null) {
  return useQuery({
    queryKey: recordInfoKeys.detail(patientId ?? ""),
    queryFn: async () => api.get<RecordInfo>(`/notes/record-info/${patientId}`),
    enabled: Boolean(patientId),
    // The shared client caches queries for five minutes. A return visit must
    // load this patient's record again, not the previous patient's cache.
    staleTime: 0,
  });
}

export default useRecordInfoQuery;
